module.exports = __webpack_public_path__ + "img/bottom-logo.85be9fdf.png";